module.exports = " <div class=\"summary-confirm text-center\"> <h2 style=\"padding-left: 0\">¡Hemos recibido tu pedido!</h2> <p class=text-center>Muchas gracias por comprar en Lasddi.com. Recibirás el resumen de tu pedido por correo electrónico. <br><br> </p> <p class=text-center> Por cualquier consulta que tengas referente a tu pedido puedes consultarnos por correo a cuentas@lasddi.com o telefónicamente al (33) 2748 2493.<br><br> </p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shopping-cart/Shopping-cart-bancomer.vue
// module id = 558
// module chunks = 0